export default __webpack_public_path__ + "static/media/zarif.6dbb8abf.png";